import { useEffect, useState } from "react";
import {
  createHighlight,
  getHighlight,
  updateHighlight,
} from "../../../apis/Ambition";
import DiscardChangeIcon from "../../../components/EditIconTable/DiscardChangeIcon";
import SaveChangeIcon from "../../../components/EditIconTable/SaveChangeIcon";
import "./environmentreport.css";
import { HeaderShow } from "./ESGmain";
import "../index.css";
import "./index.css";
import { useRef } from "react";

const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export const SaveAndDiscard = ({ clickSave, clickDiscard }) => {
  return (
    <div
      className="companydetail__option__info mt-1"
      style={{ justifyContent: "center" }}
    >
      <SaveChangeIcon click={clickSave} />
      <DiscardChangeIcon click={clickDiscard} />
    </div>
  );
};

export const Textareawithsteroids = ({
  question,
  maxLength,
  keyHighlight,
  placeholder = "Type your answer here.",
  minHeight,
}) => {
  const [text, setText] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  // const keyHighlight = "yourenvironmentalaim"
  // const maxLength = 2300

  useEffect(() => {
    handleGet();
    if (question) {
      createHighlight({ key: keyHighlight + "_question", value: question });
    }
  }, []);

  const handleGet = () => {
    getHighlight({
      key: keyHighlight,
      setValue: setText,
    });
  };

  const handleUpdate = () => {
    if (text.length <= maxLength) {
      updateHighlight({
        key: keyHighlight,
        value: text,
        swal: true,
      });
    } else {
      setErrorMessage(
        "The text may not be longer than " + maxLength + " characters"
      );
    }
  };
  return (
    <>
      <textarea
        style={minHeight ? { minHeight: minHeight } : null}
        type="text"
        placeholder={placeholder}
        value={text}
        onChange={(e) => setText(e.target.value)}
      ></textarea>
      {
        <h6>
          {text.length}/{maxLength}
        </h6>
      }
      {text.length > maxLength && errorMessage ? (
        <h6 style={{ fontSize: "0.8rem", color: "red" }}>{errorMessage}</h6>
      ) : null}
      <SaveAndDiscard clickSave={handleUpdate} clickDiscard={handleGet} />
    </>
  );
};

export const Textareawithsteroids2 = ({
  question,
  maxLength,
  keyHighlight,
  placeholder = "Type your answer here.",
  minHeight,
  size = "",
}) => {
  const [text, setText] = useState("");

  const [unstableText, setUnstableText] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  // const keyHighlight = "yourenvironmentalaim"
  // const maxLength = 2300

  useEffect(() => {
    handleGet();
    if (question) {
      createHighlight({ key: keyHighlight + "_question", value: question });
    }
  }, [keyHighlight]);

  const handleGet = () => {
    getHighlight({
      key: keyHighlight,
      setValue: setUnstableText,
    });
  };

  const handleUpdate = () => {
    if (text.length <= maxLength) {
      updateHighlight({
        key: keyHighlight,
        value: text,
        swal: false,
      });
    } else {
      setErrorMessage(
        "The text may not be longer than " + maxLength + " characters"
      );
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setText(unstableText), 1000);
    return () => clearTimeout(timer);
  }, [unstableText]);

  useEffect(() => {}, [text]);

  useEffect(() => {
    if (text != "") handleUpdate();
  }, [text]);

  return (
    <>
      {size === "small" ? (
        <input
          className="w-100"
          type="text"
          value={unstableText}
          onChange={(e) => setUnstableText(e.target.value)}
          placeholder={placeholder}
        />
      ) : (
        <textarea
          style={minHeight ? { minHeight: minHeight } : null}
          type="text"
          placeholder={placeholder}
          value={unstableText}
          onChange={(e) => setUnstableText(e.target.value)}
        ></textarea>
      )}
      {size === "small" ? (
        <></>
      ) : (
        <h6>
          {text.length}/{maxLength}
        </h6>
      )}
      {text.length > maxLength && errorMessage ? (
        <h6 style={{ fontSize: "0.8rem", color: "red" }}>{errorMessage}</h6>
      ) : null}
    </>
  );
};

const EnvironmentReport = () => {
  const [showContent, setShowContent] = useState(false);
  return (
    <div className="environmentreport mt-2">
      <Scopes />
      <EnergyAndWater />
      <ActiveParticipation />
      <HeaderShow
        text={"Your Environmental Aim"}
        show={showContent}
        setShow={() => setShowContent(!showContent)}
      />
      {showContent ? (
        <div className="col-md-11 mx-auto">
          <div className="esg__companyinfo__header mb-1 environmentalaim">
            <h6>
              What does your company passionately care about in this category ?
              Have you created a benchmark just for that?{" "}
            </h6>
          </div>
          <div className="esg__leader__value mt-2 p-5 pt-3 pb-3 environmentalaim">
            <Textareawithsteroids
              maxLength={3000}
              keyHighlight={"yourenvironmentalaim"}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

const Scopes = () => {
  const [showContent, setShowContent] = useState(false);
  return (
    <>
      <HeaderShow
        text={"Scopes"}
        show={showContent}
        setShow={() => setShowContent(!showContent)}
      />
      {showContent ? (
        <div className="esg__companyinfo__values esg__scopes">
          <div className="esg__companyinfo__leader">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to reduce
                your scope 1 emissions ?
              </h6>
            </div>
            <div className="esg__leader__value p-4 mb-1">
              <Textareawithsteroids maxLength={850} keyHighlight={"scope1"} />
            </div>
          </div>
          <div className="esg__companyinfo__highlight">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to reduce
                your scope 2 emissions ?
              </h6>
            </div>
            <div className="esg__highlight__value p-4 mb-1">
              <Textareawithsteroids maxLength={850} keyHighlight={"scope2"} />
            </div>
          </div>
          <div className="esg__companyinfo__leader">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to reduce
                your scope 3 emissions ?
              </h6>
            </div>
            <div className="esg__leader__value p-4 mb-1">
              <Textareawithsteroids maxLength={850} keyHighlight={"scope3"} />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

const EnergyAndWater = () => {
  const [showContent, setShowContent] = useState(false);
  return (
    <>
      <HeaderShow
        text={"Energy Resources & Water Usage"}
        show={showContent}
        setShow={() => setShowContent(!showContent)}
      />
      {showContent ? (
        <div className="esg__companyinfo__values esg__energywater">
          <div className="esg__companyinfo__leader">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to reduce
                your your use of water and creation of waste water?
              </h6>
            </div>
            <div className="esg__leader__value p-4 mb-1">
              <Textareawithsteroids
                maxLength={300}
                keyHighlight={"energyinitiative"}
              />
            </div>
          </div>
          <div className="esg__companyinfo__highlight">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to reduce
                your your use of energy and transition towards 100% renewable
                sources? How far along are you? Thoughts on becoming emission's
                free
              </h6>
            </div>
            <div className="esg__highlight__value p-4 mb-1">
              <Textareawithsteroids
                maxLength={300}
                keyHighlight={"waterinitiative"}
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

const ActiveParticipation = () => {
  const [showContent, setShowContent] = useState(false);
  return (
    <>
      <HeaderShow
        text={"Active Participation"}
        show={showContent}
        setShow={() => setShowContent(!showContent)}
      />
      {showContent ? (
        <div className="esg__companyinfo__values esg__scopes">
          <div className="esg__companyinfo__leader">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to reduce
                your overall waste and incineration of any of the waste?
              </h6>
            </div>
            <div className="esg__leader__value p-4 mb-1">
              <Textareawithsteroids
                maxLength={400}
                keyHighlight={"wasteinitiative"}
              />
            </div>
          </div>
          <div className="esg__companyinfo__highlight">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to enhance
                circular economy and redirect surplus resources into nutrient
                flows, so the material can be used at the highest value for the
                longest period ?
              </h6>
            </div>
            <div className="esg__highlight__value p-4 mb-1">
              <Textareawithsteroids
                maxLength={400}
                keyHighlight={"circularinitiative"}
              />
            </div>
          </div>
          <div className="esg__companyinfo__leader">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to reduce
                your use of virgin materials and thus your company strain on
                natures reserves ?
              </h6>
            </div>
            <div className="esg__leader__value p-4 mb-1">
              <Textareawithsteroids
                maxLength={400}
                keyHighlight={"virgininitiative"}
              />
            </div>
          </div>
          <div className="esg__companyinfo__leader">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                What initiatives have you implemented in the company to
                regenerate nature, and not use more than nature can renew?
              </h6>
            </div>
            <div className="esg__leader__value p-4 mb-1">
              <Textareawithsteroids
                maxLength={400}
                keyHighlight={"regenerateinitiative"}
              />
            </div>
          </div>
          <div className="esg__companyinfo__leader">
            <div className="esg__companyinfo__header mb-2">
              <h6>
                Have you made any initiatives towards not harming, but
                preserving and regenerating nature, wildlife and insects in the
                areas you source from?
              </h6>
            </div>
            <div className="esg__leader__value p-4 mb-1">
              <Textareawithsteroids
                maxLength={400}
                keyHighlight={"wildlifeinitiative"}
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default EnvironmentReport;
